import { accountPartnersSchema, accountBalancesSchema, accountHistorySchema, accountPositionsSchema, balanceRefreshSchema, historySyncSchema, } from "../schemas/index.js";
/**
 * The `/auth/account/*` surface — router-account summary, per-currency balances,
 * and raw venue history. For an `owner_self` org key the account is inferred from
 * the key (no `X-OpenMarkets-Account` header). NOTE: the raw `partners()` payload
 * contains `encrypted_credentials`; the greenbook proxy strips it before it ever
 * reaches the browser.
 */
export class AccountResource {
    http;
    constructor(http) {
        this.http = http;
    }
    /** Router-account summary: total balance, per-currency totals, connected venues. */
    partners() {
        return this.http.request({
            method: "GET",
            path: "/auth/account/partners",
            endpoint: "account.partners",
            dataSchema: accountPartnersSchema,
        });
    }
    /** Balances grouped by currency (real-money USD + play-money ATLAS), each with per-venue rows. */
    balances() {
        return this.http.request({
            method: "GET",
            path: "/auth/account/balances",
            endpoint: "account.balances",
            dataSchema: accountBalancesSchema,
        });
    }
    /** Raw venue events (fills + transactions), newest first. */
    history(params = {}) {
        return this.http.request({
            method: "GET",
            path: "/auth/account/history",
            endpoint: "account.history",
            query: { limit: params.limit, cursor: params.cursor },
            dataSchema: accountHistorySchema,
        });
    }
    /**
     * `GET /auth/account/positions` — the REST positions rollup (Round-2, PR #599,
     * live 2026-07-15), replacing the MCP `list_account_positions` bridge. Same row
     * shape as the MCP tool. `net_pnl` is `null` for OPEN positions.
     *
     * `status=open|settled|all` (live 2026-07-15) filters server-side: `open` returns
     * just the current holdings in one cheap call — no need to page the whole lifetime
     * book to surface them. Omitting `status` returns the full rollup.
     */
    positions(params = {}) {
        return this.http.request({
            method: "GET",
            path: "/auth/account/positions",
            endpoint: "account.positions",
            query: { status: params.status, limit: params.limit, cursor: params.cursor },
            dataSchema: accountPositionsSchema,
        });
    }
    /**
     * `POST /auth/account/history/sync` — dispatches a fire-and-forget per-venue
     * re-sync of the raw venue ledger (Round-2, PR #603, live 2026-07-15). Returns
     * immediately with the dispatched partner ids; the ledger + positions rollup
     * update async over the next few seconds.
     */
    syncHistory() {
        return this.http.request({
            method: "POST",
            path: "/auth/account/history/sync",
            endpoint: "account.syncHistory",
            body: {},
            dataSchema: historySyncSchema,
        });
    }
    /**
     * `POST /auth/account/partners/balance/update` — re-reads live balances from
     * every connected venue. Slow (1–3s); don't poll (user action or ≥30s timer).
     * Returns the partners envelope plus `refreshed_partner_ids`.
     */
    refreshBalances() {
        return this.http.request({
            method: "POST",
            path: "/auth/account/partners/balance/update",
            endpoint: "account.refreshBalances",
            body: {},
            dataSchema: balanceRefreshSchema,
        });
    }
}
//# sourceMappingURL=account.js.map